import HtmlElement from './HtmlElement';

/**
 * Adds collapse / expand functionality to collapsible content
 */
class CollapsibleContent extends HtmlElement {

	constructor() {
		super({});
	}

	exists() {
		return true;
	}

	onReady() {
		let collapseToggles = $('.toggleCollapsedContent');

		collapseToggles.on('click', e => {
			this.onClick(e);
		});

		collapseToggles.each((index, element) => {
			let $element = $(element).find('.collapseTitle');

			if(!this.checkBreak($element.html())) {
                $element.html(this.spaceToBreak($element.html()));
			}

            if(!this.checkBreak($element.data('toggletitle'))) {
                $element.data('toggletitle', this.spaceToBreak($element.data('toggletitle')));
            }
		});
	}

	onClick(e) {
		e.preventDefault();

		let $target = $(e.target),
			$container = $target.parents('.collapsible'),
			$collapsibleContent = $container.find('.collapsedContent'),
			$icon = $container.find('.toggleCollapsedContent img'),
			$title = $container.find('.collapseTitle'),
			currentIconUri = $icon.attr('src'),
			currentTitle = $title.html();

		$collapsibleContent.slideToggle();
		$icon.attr('src', $icon.data('toggleimage')).data('toggleimage', currentIconUri);
		$title.html($title.data('toggletitle')).data('toggletitle', currentTitle);
	}

	spaceToBreak(string) {
		return string.replace(/ /g, '<br>');
	}

	checkBreak(string) {
		return string.includes("<br/>") || string.includes("<br />") || string.includes("<br>");
	}
}

export default (new CollapsibleContent());